/**
 * Content reference parsing for the "carId/skinId" and "trackId/layoutId"
 * composite strings stored on events (carsAvailable), sessions (car/track) and
 * lap-times.
 *
 * The TAIL (skinId / layoutId) never contains a slash, but the HEAD can:
 * an rF2 car_id is the VEH directory under Installed/Vehicles
 * (e.g. "Tatuus_F3_T318_2019/1.45", or ".../teams" for team liveries), so the
 * composite "{carId}/{skinId}" may carry multiple slashes. Always split on the
 * LAST slash so the head is recovered intact regardless of how many slashes it
 * holds. AC content (slash-free ids) and track refs (single slash) parse
 * identically, so this is a safe drop-in for the old first-slash split.
 */
export function splitContentRef(raw) {
    if (!raw)
        return { head: "", tail: undefined };
    const i = raw.lastIndexOf("/");
    if (i < 0)
        return { head: raw, tail: undefined };
    return { head: raw.slice(0, i), tail: raw.slice(i + 1) };
}
/** Parse a "carId/skinId" composite. carId may contain slashes (rF2 vehicle/version). */
export function parseCarRef(raw) {
    const { head, tail } = splitContentRef(raw);
    return { carId: head, skinId: tail };
}
/** Parse a "trackId/layoutId" composite. */
export function parseTrackRef(raw) {
    const { head, tail } = splitContentRef(raw);
    return { trackId: head, layoutId: tail };
}
//# sourceMappingURL=content-ref.js.map